module.exports = {"230826101":"横头山镇","230826103":"苏家店镇","230826104":"悦来镇","230826105":"新城镇","230826106":"四马架镇","230826201":"东河乡","230826202":"梨丰乡","230826205":"创业乡","230826207":"星火乡","230826500":"江川农场","230826501":"宝山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230826.json
// module id = 705
// module chunks = 0